import { render, staticRenderFns } from "./FloatButton.vue?vue&type=template&id=6b64fe3e&scoped=true"
import script from "./FloatButton.vue?vue&type=script&lang=js"
export * from "./FloatButton.vue?vue&type=script&lang=js"
import style0 from "./FloatButton.vue?vue&type=style&index=0&id=6b64fe3e&prod&lang=scss&scoped=true"
import style1 from "./FloatButton.vue?vue&type=style&index=1&id=6b64fe3e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b64fe3e",
  null
  
)

export default component.exports